/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setHeaderTransform.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * 初期設定
 */
// const headerNav = document.getElementById("header");
const body = document.body;

/**
 * ヘッダー変形
 */
const setHeaderTransform = () => {
  if (window.document.body.classList.contains("home")) {
    var targetElement = document.getElementById("site-mv");
    var clientRect = targetElement.getBoundingClientRect();
    var py = window.pageYOffset + clientRect.top;
    const transform = () => {
      if (window.pageYOffset > clientRect.height) {
        body.classList.add("transform");
      } else if (window.pageYOffset < clientRect.height) {
        body.classList.remove("transform");
      }
    }
    window.addEventListener("scroll", transform);
  }
}

/**
 * ActionTo.
 */
export {
  setHeaderTransform
}